// extracted by mini-css-extract-plugin
export default {"LoginHead":"loginHead_LoginHead__pWqo5","btn_r":"loginHead_btn_r__fIXkA"};